function retry(fn, retriesLeft = 3, interval = 2500) {
    return new Promise((resolve, reject) => {
      fn()
        .then(resolve)
        .catch((error) => {
          setTimeout(() => {
            if (retriesLeft === 1) {
              // reject('maximum retries exceeded');
              window.location.reload();
              // reject(error);
              return false;
            }
  
            // Passing on "reject" is the important part
            retry(fn, interval, retriesLeft - 1).then(resolve, reject);
          }, interval);
        });
    });
  }

export default retry;